export const SET_ORIGIN = 'SET_ORIGIN';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const SET_PUBLICKEY = 'SET_PUBLICKEY';
export const SET_IS_CITA_FLOW = 'SET_IS_CITA_FLOW';
export const SET_BUTTON_URL = 'SET_BUTTON_URL';
export const SET_CUSTOMER_ID = 'SET_CUSTOMER_ID';
export const SET_CART_COUNTRY = 'SET_CART_COUNTRY';
export const SET_APPOINTMENT_DATE = 'SET_APPOINTMENT_DATE';
export const SET_APPOINTMENT_CENTER = 'SET_APPOINTMENT_CENTER';
